// @ts-nocheck

import React from "react";
import { bool, func } from "prop-types";

const Fullscreen = React.memo(({ isFullscreen, onClick }) => {

  const buttonClass = `image-gallery-icon image-gallery-fullscreen-button ${
    isFullscreen ? "fullscreen-active" : ""
  }`;

  return (
    <button
      type="button"
      className={buttonClass}
      onClick={onClick}
      
      aria-label=
      {isFullscreen ? "Close Fullscreen" : "Open Fullscreen"}
    >
      {isFullscreen ? "Click to close full view" : "Click to see full view"}
    </button>
  );
});

Fullscreen.displayName = "Fullscreen";

Fullscreen.propTypes = {
  isFullscreen: bool.isRequired,
  onClick: func.isRequired,
};

export default Fullscreen;
